import { memo } from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { ApiRouteTypes } from "consts/enpoints/api";
import { WebRoutes } from "consts/enpoints/web";
import useOnboardingApplication from "features/ecommerce/useOnboardingApplication";
import When from "ui/support/When";
import type { ApplicationStatusProps } from "./types";

const ApplicationStatus = ({ children, status, slotProps }: ApplicationStatusProps) => {
    const { hasStatus } = useOnboardingApplication(ApiRouteTypes.GetSettings);

    return (
        <When
            if={hasStatus(...status)}
            then={() => (
                <Box
                    {...slotProps?.root}
                    sx={{
                        display: 'grid',
                        justifyContent: 'flex-start',
                        gap: 2,
                        ...slotProps?.root?.sx
                    }}
                >
                    <Alert
                        {...slotProps?.alert}
                    >
                        {slotProps?.alert?.children ?? children}
                    </Alert>
                    <Button
                        variant='contained'
                        color='secondary'
                        href={WebRoutes.Onboarding.Index}
                        {...slotProps?.button}
                        sx={{
                            width: 'fit-content',
                            ...slotProps?.button?.sx
                        }}
                    >
                        {slotProps?.button?.children ?? 'View Application'}
                    </Button>
                </Box>
            )}
        />
    );
};

export default memo(ApplicationStatus);
